module.exports = __webpack_public_path__ + "static/media/bsa.8937261b.png";